import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { getCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  GridCardViewMultiSectionDescription,
  PlaneSize,
} from '@Components/BigBrowse/Model/ModelTypes';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';

type GetMultiSectionDescriptionCards = {
  viewData: ViewData;
  size: PlaneSize;
  dx?: number;
  layout?: GridCardViewMultiSectionDescription['layout'];
};

export function getMultiSectionDescriptionCards({
  viewData,
  size,
  dx = 0,
  layout = 'full',
}: GetMultiSectionDescriptionCards): GridCard<PlaneTypes.Card_MultiSection_Description> {
  const card = getCard<PlaneTypes.Card_MultiSection_Description>({
    type: PlaneTypes.Card_MultiSection_Description,
    size,
    blockHover: true,
    data: {
      id: ['BrandConcessionDescription', viewData.modelData.concessionId].join(
        '_'
      ),
      key: ['BrandConcessionDescription', viewData.modelData.concessionId].join(
        '_'
      ),
      title: viewData.modelData.header!.title,
      body: viewData.modelData.header!.text,
      fontColor: viewData.modelData.header!.fontColour,
      type: undefined,
      dataModel: viewData.modelData,
      dx,
      layout,
    },
  });

  card.key = card.data?.key;

  return card;
}

type GetMultiSectionHeroDescriptionCardParams = {
  viewData: ViewData;
  size: PlaneSize;
  dx?: number;
  layout?: GridCardViewMultiSectionDescription['layout'];
};

export function getMultiSectionHeroDescriptionCard({
  viewData,
  size,
  dx = 0,
  layout = 'full',
}: GetMultiSectionHeroDescriptionCardParams): GridCard<PlaneTypes.Card_MultiSection_Description> {
  const card = getCard<PlaneTypes.Card_MultiSection_Description>({
    type: PlaneTypes.Card_MultiSection_Description,
    size,
    blockHover: true,
    data: {
      id: [
        'BrandConcessionHeroDescription',
        viewData.modelData.concessionId,
      ].join('_'),
      key: [
        'BrandConcessionHeroDescription',
        viewData.modelData.concessionId,
      ].join('_'),
      // title: viewData.modelData.header!.heroImageTitle,
      // body: viewData.modelData.header!.heroImageText,
      type: undefined,
      dataModel: viewData.modelData,
      dx,
      layout,
    },
  });

  card.key = card.data?.key;

  return card;
}
